import { render, staticRenderFns } from "./WhiteContacts.vue?vue&type=template&id=5704757d&scoped=true&"
import script from "./WhiteContacts.vue?vue&type=script&lang=js&"
export * from "./WhiteContacts.vue?vue&type=script&lang=js&"
import style0 from "./WhiteContacts.vue?vue&type=style&index=0&id=5704757d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704757d",
  null
  
)

export default component.exports